<template>
  <div class="wh-screen">
    <global-confirm-box ref="confirmBox" />
    <warehouse-return-dialog
      v-model="returnDialog"
      :edited-item="editedItem"
      :warehouse="filters.warehouse[0]"
      @groceriesReturned="addDocuments"
      @save="save"
      @success="onSuccess"
    />
    <warehouse-doc-screen
      v-bind="docProps"
      :mobile="device.isMobile"
      @update:aggregate="aggregateMode = $event"
      @hint="setFiltersToLastEntry"
      @action="onDocAction"
      @open-row="openRowDoc"
      @toast="$emit('toast', $event)"
    >
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
      <template #detail-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabReturn from "@/components/warehouse/tabs/WarehouseTabReturn.vue";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";
import hasDocumentListScreen from "../../docs/hasDocumentListScreen";

/**
 * Povrat robe: lista dokumenata ili zbirni prikaz po artiklu, "Povrat robe" u traci alata. Nasleđuje učitavanje,
 * filtriranje, brisanje, čuvanje, štampu, Excel i dijalog iz starog taba.
 */
export default {
  name: "WarehouseScreenReturn",
  extends: WarehouseTabReturn,
  mixins: [hasDocumentListScreen],
  components: { WarehouseDocScreen, WarehouseRowButton },
  computed: {
    docConfig() {
      return {
        icon: "mdi-backup-restore",
        hintKey: "warehouse.last_return",
        emptyTitleKey: "no_returns",
        emptyTextKey: "no_returns_yet",
        dateLabel: this.$t("warehouse.return_date"),
        open: "openDocument",
        remove: "deleteItem",
        run: "openReturnDialog",
        action: { key: "return", label: this.$t("warehouse.return_goods"), icon: "mdi-backup-restore", tone: "pri" },
      };
    },
  },
};
</script>
